import { useAppSelector } from '@/store/hooks'
import type { WorkspaceResponse } from '@/api'

/**
 * 워크스페이스의 세부실행과제 표시 여부.
 * 구버전 응답·localStorage 캐시에는 필드가 없을 수 있으므로, false 로 명시된 경우만 숨긴다.
 */
export const getWorkspaceShowTasks = (workspace: WorkspaceResponse | null | undefined): boolean =>
  workspace?.show_tasks !== false

/**
 * 현재 선택된 워크스페이스에서 현황·성과보고서 화면의 세부실행과제 영역을 표시할지 판정.
 * 설정은 워크스페이스 관리 > 워크스페이스 수정에서 바꾼다.
 */
export const useShowTasks = (): boolean => {
  const selectedWorkspace = useAppSelector(state => state.workspace.selectedWorkspace)
  return getWorkspaceShowTasks(selectedWorkspace)
}
